<template>
  <AuthLockBlock class="demo__flex-inline">
    <a-button
      class="demo__button demo__button--gray demo__margin-right--22 demo__margin-right-mobile--0"
      @click="$root.$emit('downloadOrigStudy')"
    >
      <i class="fa-light fa-arrow-down-to-line"></i>
      <span class="demo__margin-left--9" v-if="windowWidth > 1630">
        {{ $t("Download") }}
      </span>
    </a-button>
  </AuthLockBlock>
</template>

<script>
export default {
  props: {
    windowWidth: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      process: false,
      process_text: false,
      timeout: undefined,
    };
  },
  watch: {
    process(val) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.process_text = val;
      }, 100);
    },
  },
  mounted() {
    this.$accessModule("copy_page", this);
  },
  methods: {
    copy() {
      if (this.process) {
        return;
      }
      this.process = true;
      this.$root.$emit("copyShareString");

      setTimeout(() => {
        this.process = false;
      }, 2000);
    },
  },
};
</script>
